/* eslint-disable react/sort-comp */
/* eslint-disable eqeqeq */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getRegionsByCountryId } from '../../../../Utils/ElasticUtils';
import {
  POPULAR,
  OTHER,
  ALL_RESORTS,
} from '../../../../Utils/Constants/SearchFormConstants';
import { TURKEY_COUNTRY_ID } from '../../../../Utils/Constants/GlobalConstants';
import {
  changeSelectedResorts,
  changeResortOptions,
  changeDestination,
  changeSearchInputValue,
  changeCharterOnly,
} from '../../../../DataStore/actions/searchFormActions';
import { changeHotelsFilter } from '../../../../DataStore/actions/FiltersAction';
import './css/ResortsPopup.css';
import { TOUR_SEARCH_REGIONS_INDEX } from '../../../../Utils/Constants/Indexes';
import { countries } from '../../../../Utils/Constants/countries';
import { ReactComponent as DefaultCheck } from '../../../../images/default-check-r.svg';
import { ReactComponent as ActiveCheck } from '../../../../images/active-check-r.svg';
import { ReactComponent as ArrowRight } from '../../../../images/gray-arrow-right-r.svg';
import { getShortString } from '../../../../Utils/CommonUtils';

const mapStateToProps = (state) => ({ ...state });

class ResortsPopup extends React.Component {
  constructor(props) {
    super(props);
    this.selectedCountryRef = React.createRef();
    this.resortsRef = React.createRef();

    const { selectedResorts } = this.props;
    this.state = {
      isAllResortsChecked: selectedResorts.length === 0,
      countryOptions: [],
      resortOptions: [],
      selectedCountryIndex: 0,
    };
  }

  componentDidMount() {
    const { destination } = this.props;
    const { resortOptions } = this.state;

    const countryOptions = countries.map((country) => ({
      ...country,
      checked: country.id == destination.id,
    }));

    countryOptions.forEach((e, index) => {
      if (e.checked) {
        this.setState({ selectedCountryIndex: index });
      }
    });

    this.setState({ countryOptions });

    if (resortOptions.length === 0) {
      this.getResortsOptions(destination.id);
    }
  }

  componentDidUpdate() {
    this.scrollCountry();
  }

  async scrollCountry() {
    const { selectedCountryIndex } = this.state;
    await this.timeout(300);

    if (this.selectedCountryRef.current) {
      this.selectedCountryRef.current.scrollTo({
        top: selectedCountryIndex * 40, // 40px - height of item
        behavior: 'smooth',
      });
    }
  }

  async scrollResorts() {
    await this.timeout(300);

    if (this.resortsRef.current) {
      this.resortsRef.current.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }

  async timeout(delay) {
    return new Promise((res) => {
      setTimeout(res, delay);
    });
  }

  getResortsOptions = (id) => {
    const { selectedResorts } = this.props;

    getRegionsByCountryId(id, TOUR_SEARCH_REGIONS_INDEX).then((res) => {
      const { hits } = res.data;
      if (hits) {
        const resource = hits.hits.map((h) => h._source);

        const regions = resource.map((item) => ({
          ...item,
          checked:
            selectedResorts.filter((selected) => selected.id === item.id)
              .length === 1,
        }));

        this.setState({ resortOptions: regions });
      }
    });
  };

  renderCities = (citySuggestions) =>
    citySuggestions.map((item, index) => (
      <button
        type="button"
        key={`city-${index}`}
        className="sf_res_item br_text_18"
        onClick={() => this.handleResortCheckbox(item)}
      >
        <div className="sf_res_item_check_w">
          {item.checked ? (
            <ActiveCheck className="sf_res_item_check_ico" />
          ) : (
            <DefaultCheck className="sf_res_item_check_ico" />
          )}

          <div>{getShortString(item.name, 16)}</div>
        </div>
      </button>
    ));

  renderCountries = (allCountries) =>
    allCountries.map((item, index) => {
      const { destination } = this.props;
      return (
        <button
          type="button"
          key={`country-${index}`}
          className="sf_res_item br_text_18"
          onClick={() => {
            this.selectCountry(item, index);
          }}
        >
          <div className="sf_res_item_check_w">
            {destination.id === item.id && (
              <ActiveCheck className="sf_res_item_check_ico" />
            )}

            <div>{item.name}</div>
          </div>

          {destination.id === item.id && <ArrowRight />}
        </button>
      );
    });

  selectHotel = (hotel) => {
    const {
      hotelsFilter,
      changeHotelsFilter: changeHotelsFilterAction,
      destination,
      changeSearchInputValue: changeSearchInputValueAction,
    } = this.props;

    const newHotelsFiltesState = hotelsFilter.filter((e) => e.id !== hotel.id);
    changeHotelsFilterAction(newHotelsFiltesState);

    if (newHotelsFiltesState.length === 0) {
      changeSearchInputValueAction(destination.name);
    }
  };

  renderHotels = (selectedHotels) =>
    selectedHotels.map((item, index) => (
      <div key={`hotel-${index}`}>
        <button
          type="button"
          key={`hotel-${index}`}
          className="sf_res_hotel_item br_text_18"
          onClick={() => this.selectHotel(item)}
        >
          <div className="sf_res_item_check_w">
            {item.checked ? (
              <div className="sf_res_item_check_ico">
                <ActiveCheck />
              </div>
            ) : (
              <div className="sf_res_item_check_ico">
                <DefaultCheck />
              </div>
            )}

            <div>{item.name}</div>
          </div>
        </button>
      </div>
    ));

  selectCountry = (item, index) => {
    const {
      changeDestination: changeDestinationAction,
      changeSearchInputValue: changeSearchInputValueAction,
      changeSelectedResorts: changeSelectedResortsAction,
      changeCharterOnly: changeCharterOnlyFunc,
      changeHotelsFilter: changeHotelsFilterAction,
    } = this.props;

    const { countryOptions } = this.state;

    const countryOptionsNewState = countryOptions.map((country) => ({
      ...country,
      checked: country.id === item.id,
    }));

    this.setState({
      countryOptions: countryOptionsNewState,
      isAllResortsChecked: true,
      selectedCountryIndex: index,
    });

    changeDestinationAction(item);
    changeSearchInputValueAction(item.name);
    changeSelectedResortsAction([]);
    changeHotelsFilterAction([]);

    this.getResortsOptions(item.id);

    changeCharterOnlyFunc(item.id === TURKEY_COUNTRY_ID);
    this.scrollResorts();
  };

  handleResortCheckbox = (item) => {
    const {
      changeSelectedResorts: changeSelectedResortsAction,
      changeHotelsFilter: changeHotelsFilterAction,
      changeSearchInputValue: changeSearchInputValueAction,
      hotelsFilter,
    } = this.props;
    const { resortOptions } = this.state;

    const resortOptionsNewState = resortOptions.map((e) => {
      if (item.id === e.id) {
        return {
          ...e,
          checked: !e.checked,
        };
      }

      return e;
    });

    this.setState({
      resortOptions: resortOptionsNewState,
      isAllResortsChecked:
        resortOptionsNewState.filter((e) => e.checked).length === 0,
    });

    changeSelectedResortsAction(resortOptionsNewState.filter((e) => e.checked));

    // ????
    if (hotelsFilter.length > 0) {
      changeSearchInputValueAction(item.countryName);
      changeHotelsFilterAction([]);
    }
  };

  toggleAllResortsCheckbox = () => {
    const { changeSelectedResorts: changeSelectedResortsAction } = this.props;
    const { isAllResortsChecked, resortOptions } = this.state;

    if (!isAllResortsChecked) {
      const resortOptionsNewState = resortOptions.map((e) => ({
        ...e,
        checked: false,
      }));

      this.setState({
        isAllResortsChecked: true,
        resortOptions: resortOptionsNewState,
      });

      changeSelectedResortsAction([]);
    }
  };

  compareName = (a, b) => {
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();

    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    return 0;
  };

  renderResorts = () => {
    const { resortOptions, isAllResortsChecked } = this.state;

    if (resortOptions.length <= 4) {
      return (
        <div>
          <button
            type="button"
            key="all-resorts"
            className="sf_res_item br_text_18"
            onClick={() => this.toggleAllResortsCheckbox()}
          >
            <div className="sf_res_item_check_w">
              {isAllResortsChecked ? (
                <ActiveCheck className="sf_res_item_check_ico" />
              ) : (
                <DefaultCheck className="sf_res_item_check_ico" />
              )}

              <div>{ALL_RESORTS}</div>
            </div>
          </button>
          {this.renderCities(resortOptions)}
        </div>
      );
    } else {
      const popularResorts = resortOptions
        .filter((item) => item.popular)
        .sort(this.compareName);

      const otherResorts = resortOptions
        .filter((item) => !item.popular)
        .sort(this.compareName);

      return (
        <div>
          <button
            type="button"
            key="all-resorts"
            className="sf_res_item br_text_18"
            onClick={() => this.toggleAllResortsCheckbox()}
          >
            <div className="sf_res_item_check_w">
              {isAllResortsChecked ? (
                <ActiveCheck className="sf_res_item_check_ico" />
              ) : (
                <DefaultCheck className="sf_res_item_check_ico" />
              )}

              <div>{ALL_RESORTS}</div>
            </div>
          </button>

          {popularResorts.length > 0 && (
            <div className="sf_res_delimenter_w">
              <div className="gr_text_11">{POPULAR}</div>
            </div>
          )}

          {this.renderCities(popularResorts)}

          {popularResorts.length > 0 && otherResorts.length > 0 && (
            <div className="sf_res_delimenter_w">
              <div className="gr_text_11">{OTHER}</div>
            </div>
          )}

          {otherResorts.length > 0 && this.renderCities(otherResorts)}
        </div>
      );
    }
  };

  render() {
    const { hotelsFilter } = this.props;
    const { countryOptions } = this.state;

    return (
      <div>
        {hotelsFilter.length > 0 ? (
          <div className="sf_hotel_res_wrapper">
            <div className="sf_res_hotels_w">
              {this.renderHotels(hotelsFilter)}
            </div>
          </div>
        ) : (
          <div className="sf_res_wrapper">
            <div
              className="res_collumn res_collumn_left custom_scroll_container"
              ref={this.selectedCountryRef}
            >
              {this.renderCountries(countryOptions)}
            </div>
            <div
              className="res_collumn res_collumn_right custom_scroll_container"
              ref={this.resortsRef}
            >
              {this.renderResorts()}
            </div>
          </div>
        )}
      </div>
    );
  }
}

ResortsPopup.propTypes = {
  destination: PropTypes.instanceOf(Object).isRequired,
  selectedResorts: PropTypes.instanceOf(Array).isRequired,
  changeSelectedResorts: PropTypes.func.isRequired,
  changeDestination: PropTypes.func.isRequired,
  changeSearchInputValue: PropTypes.func.isRequired,
  changeCharterOnly: PropTypes.func.isRequired,
  changeHotelsFilter: PropTypes.func.isRequired,
  hotelsFilter: PropTypes.instanceOf(Array).isRequired,
};

export default connect(mapStateToProps, {
  changeSelectedResorts,
  changeResortOptions,
  changeDestination,
  changeSearchInputValue,
  changeCharterOnly,
  changeHotelsFilter,
})(ResortsPopup);
